import React, { useContext, useEffect, useState } from "react";
import { SearchRounded } from "@mui/icons-material";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/ChatContext";

export default function Search({ placeholder, group, members, setMembers }) {
  const [username, setUsername] = useState("");
  const [user, setUser] = useState([]);
  const [err, setErr] = useState(false);

  const { currentUser } = useContext(AuthContext);
  const { dispatch } = useContext(ChatContext);

  const handleSearch = async () => {
    setErr(false);
    if (!username) return;
    setUser("");
    const usersRef = collection(db, "users");
    const q = query(
      usersRef,
      where("query", "array-contains", username.toLowerCase())
    );
    try {
      const querySnapshot = await getDocs(q);
      if (querySnapshot.docs.length === 0) {
        setErr(true);
        return;
      }
      querySnapshot.forEach((doc) => {
        let newData = doc.data();
        if (user.indexOf((item) => item.uid === newData.uid) === -1)
          setUser((prev) => [...prev, doc.data()]);
      });
    } catch (error) {
      setErr(true);
    }
  };

  const handleKey = (e) => {
    e.code === "Enter" && handleSearch();
  };

  const handleSelect = async (user) => {
    if (!group) {
      const combinedId =
        currentUser.uid > user.uid
          ? currentUser.uid + user.uid
          : user.uid + currentUser.uid;
      dispatch({
        type: "CHANGE_USER",
        payload: { ...user, chatId: combinedId },
      });
      try {
        const userChats = await getDoc(doc(db, "userChats", currentUser.uid));
        if (!userChats.exists()) {
          await setDoc(doc(db, "userChats", currentUser.uid), {
            [combinedId]: {
              userInfo: {
                uid: user.uid,
                displayName: user.displayName,
                photoURL: user.photoURL,
              },
              date: serverTimestamp(),
            },
          });
        }
        const res = await getDoc(doc(db, "chats", combinedId));

        if (!res.exists()) {
          //create chat in chats collection
          await setDoc(doc(db, "chats", combinedId), { messages: [] });
        }
      } catch (error) {
        setErr(true);
      }
    } else {
      group && setMembers((prev) => [...prev, user]);
      console.log(members);
    }

    setUser([]);
    setUsername("");
  };

  useEffect(() => {
    setUser([]);
    handleSearch();
  }, [username]);

  return (
    <div className="search">
      {group && (
        <p className="members">
          members - {members.map((member) => `@${member.displayName}`)}
        </p>
      )}
      <div className="searchForm">
        <input
          type="text"
          placeholder={placeholder ? placeholder : "find a user..."}
          onKeyDown={handleKey}
          onChange={(e) => {
            setUsername(e.target.value);
          }}
          value={username}
        />

        <SearchRounded className="icon" onClick={handleSearch} />
      </div>
      {err && <span style={{marginLeft:"10px",color:"#6c6c6c"}}>No users found.</span>}
      {user &&
        user.map((userData) => {
          if (userData.uid === currentUser.uid) return null;
          return (
            <div className="userChat" onClick={() => handleSelect(userData)}>
              <img
                src={
                  userData.photoURL ||
                  "https://cdn-icons-png.flaticon.com/128/2202/2202112.png"
                }
                alt=""
              />
              <div className="userChatInfo">
                <span className="username">{userData.displayName}</span>
              </div>
            </div>
          );
        })}
    </div>
  );
}
